// extracted by mini-css-extract-plugin
export var documentation = "_ig-1";
export var menu = "_ig-0";